import React from "react";
import "../../resources/css/application.css";
import logoWhite from "../../resources/images/logo-white.svg";

const Footer = () => {

  return (
    <div>

      <footer className="site-footer">
        <div className="container">

          <div className="site-footer__content">
            <a href="https://www.otpbanka.hr/" className="site-footer__logo" title="OTP banka d.d.">
              <img alt={""} src={logoWhite}/>
            </a>
            <p className="site-footer__copyright">© OTP banka d.d. {new Date().getFullYear()}. Sva prava pridržana.</p>
          </div>

        </div>
      </footer>

    </div>

  );
};

export default Footer;
